import { useState } from "react";
import { supabase } from "@/services/supabase";
import { toast } from "sonner";

/**
 * Custom hook for creating Stripe subscription checkout sessions
 * @returns Object with loading state, error, and createCheckout function
 */
export function useStripeCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createCheckout = async (priceId: string) => {
    try {
      setLoading(true);
      setError(null);

      // Call edge function to create checkout session
      const { data, error: functionError } = await supabase.functions.invoke("create-checkout", {
        body: { price_id: priceId },
      });

      if (functionError) {
        throw new Error(functionError.message);
      }

      if (!data || !data.url) {
        throw new Error("Failed to create checkout session");
      }

      // Redirect to Stripe checkout
      // Using window.location.href instead of window.open to avoid mobile popup blockers
      window.location.href = data.url;
      
      toast.success("Redirecting to checkout...");
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to create checkout";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, createCheckout };
}
